import { useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getRemoteCode() {
  let code = localStorage.getItem('stig-remote-code');
  if (!code) {
    code = Math.random().toString(36).slice(2, 8).toUpperCase();
    localStorage.setItem('stig-remote-code', code);
  }
  return code;
}

// Pollt die Fernbedienungs-Queue und simuliert Pfeiltasten —
// damit greifen Fragmente + Pause-Musik-Logik automatisch.
export function useRemoteControl() {
  useEffect(() => {
    if (process.env.REACT_APP_STANDALONE === 'true') return undefined;
    const code = getRemoteCode();
    let since = 0;
    let stopped = false;
    let timer = null;

    const tick = async () => {
      try {
        const { data } = await axios.get(`${API}/remote/${code}/poll`, { params: { since } });
        since = data.seq;
        for (const c of data.commands) {
          const key = c.cmd === 'prev' ? 'ArrowLeft' : 'ArrowRight';
          window.dispatchEvent(new KeyboardEvent('keydown', { key, bubbles: true }));
        }
      } catch (e) { /* offline/poll error — einfach weiter versuchen */ }
      if (!stopped) timer = setTimeout(tick, 700);
    };
    // ersten Poll ausführen, um seq zu synchronisieren (alte Kommandos verwerfen)
    (async () => {
      try {
        const { data } = await axios.get(`${API}/remote/${code}/poll`);
        since = data.seq || 0;
      } catch (e) { /* ignore */ }
      tick();
    })();

    return () => {
      stopped = true;
      clearTimeout(timer);
    };
  }, []);
}
